<template>
  <div class="d-flex align-items-center">
    <b>{{ item.name }}</b>
    <span v-if="item.security_id > 0" class="badge badge-danger ml-1" :style="{'background-color' : roles[item.security_id].colour}">{{roles[item.security_id].name}}</span>
    <span class="ml-auto">
      <span v-for="server in sortedServers" :key="server" :class="'badge ml-1 badge-' + getServerBadge(server)" style="text-transform: capitalize;">
        {{ server }}
      </span>
    </span>
  </div>
</template>

<script>
  import Roles from '../../../_roles.js'
  import Servers from '../../../_servers.js'

  export default {
    data () {
      return {
        roles: Roles
      }
    },
    props: {
      item: { required: true },
      searchText: { required: true }
    },
    computed: {
      sortedServers() {
        if (!this.item.servers) return []
        const order = ['gold', 'silver', 'red', 'blue', 'test']
        return [...this.item.servers].sort((a, b) => {
          return order.indexOf(a.toLowerCase()) - order.indexOf(b.toLowerCase())
        })
      }
    },
    methods: {
      getServerBadge(server) {
        let s = server.toLowerCase();
        if (s === 'gold') return 'warning'
        if (s === 'silver') return 'light'
        if (s === 'red') return 'danger'
        if (s === 'blue') return 'primary'
        return 'secondary'
      }
    }
  }
</script>
